export class AppSettings {
  constructor(claims: string = null) {
      if (claims != null) {
          this.setSettings(claims);
        }
    }
    setSettings(claims: any = null) {
        if ( claims["SearchDispatchs"] ) {
            this.SearchDispatchs = claims["SearchDispatchs"]
        } //User Settings
        if ( claims["DispatchBoardStatusWidth"] ) {
            this.DispatchBoardStatusWidth = claims["DispatchBoardStatusWidth"]
        }
    }
    setSettingsLoad(settings: AppSettings = null) {
        if (settings) {
            if (settings.DispatchBoardStatusWidth) {
                this.DispatchBoardStatusWidth = settings.DispatchBoardStatusWidth;
            }
            else {
                this.DispatchBoardStatusWidth = 250;
            }
            if (settings.SearchDispatchs) {
                this.SearchDispatchs = settings.SearchDispatchs;
            }
            else {
                this.SearchDispatchs = "";
            }

        }
        else {
            this.DispatchBoardStatusWidth = 250;
            this.SearchDispatchs = "";
        }
    }
    SearchDispatchs: String;
    DispatchBoardStatusWidth: Number = 250;
}
